import { render, staticRenderFns } from "./productEditName.vue?vue&type=template&id=5d8530c7&scoped=true"
import script from "./productEditName.vue?vue&type=script&lang=js"
export * from "./productEditName.vue?vue&type=script&lang=js"
import style0 from "./productEditName.vue?vue&type=style&index=0&id=5d8530c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8530c7",
  null
  
)

export default component.exports